
<template>
  <login-form-partial
      ref="loginform"
      :border="border"
      v-bind:office365LoginUrl="office365LoginUrl"
      v-bind:showPasswordLogin="samlOptions.length == 0 || showAdminLogin"
      v-on:office365login="office365login"
      v-on:login="login"
      v-on:loginSuccess="loginSuccess"
      v-on:loginWithLoginIdWhenLockedOut="loginWithLoginIdWhenLockedOut"
      v-on:loginWithMFA="loginWithMFA"
      :showWelcome="this.$root.getSetting('show_login_page_graphics')"
      :signupUrl="signupUrl">
      <template v-if="$root.getSetting('login_page_logo') != null" slot="header">
        <div class="text-center" v-if="$vuetify.breakpoint.smAndDown || !showGraphics">
          <img :src="$root.getSetting('login_page_logo')" class="logo"/>
        </div>
      </template>
      <div slot="formprefix" v-if="samlOptions.length > 0 && !showAdminLogin" style="min-height: 20vh">
        <div v-html="$t('sso_login_header', {tenancy_name: tenancyName})"></div>
        <div class="samlbuttons mt-4" v-for="saml_option in samlOptions" :key="saml_option.name">
          <r-form-submit-button v-on:click="loginWithSAML(saml_option)" data-testid="login-button">{{ $t("login_with_sso") }}</r-form-submit-button>
        </div>
        <!--<div v-if="$t('trying_to_join_meeting_tenancy') != 'trying_to_join_meeting_tenancy' && !showAdminLogin" v-html="$t('trying_to_join_meeting_tenancy', { 'webapp_link':webappLink })" class="py-2"></div>-->
        <div class="samlbuttons mt-4" v-if="!showAdminLogin">
          <v-btn text color="primary" @click="adminLogin" data-testid="a_9f040006-e51c-496a-92db-04b503162de8">{{ $t("login_other_options") }}</v-btn>
          <!--<div class="text-center pt-4" v-if="hasFeature('languageTranslations')">
            <language-button/>
          </div>-->
        </div>
      </div>
      <div slot="other-options">
        <v-btn outlined color="grey darken-2" v-on:click="showAdminLogin = false" class="ml-4 mt-2" v-if="samlOptions.length > 0">
          {{ $t("login_with_sso") }}
        </v-btn>
      </div>
      <div slot="formpostfix-inner" v-if="$t('trying_to_join_meeting_tenancy') != 'trying_to_join_meeting_tenancy'">
        <div v-html="$t('trying_to_join_meeting_tenancy', { 'webapp_link':webappLink })" class="py-4"></div>
      </div>
      <template slot="append">
        <v-dialog v-model="showTokenMFAEntry" :width="400">
          <mfa-entry :key="showTokenMFAEntry" @login="tokenLoginWithMFA($event)"/>
        </v-dialog>
      </template>
  </login-form-partial>
</template>

<script>
import LoginFormPartial from '@/components/login/LoginFormPartial';
import { sharedReactorAuthentication as authHandler} from 'reactor-js-core/dist/authentication.js'
import { dashboardUserSessionService } from 'reactor-js-core/dist/services/dashboardusersessionservice.js'
import { dashboardUserService } from 'reactor-js-core/dist/services/dashboarduserservice.js'
import { samlService } from 'reactor-js-core/dist/services/samlservice.js'
import utils from 'reactor-js-core/dist/utils.js'
import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'
import { mapGetters } from 'vuex';
import MFAEntry from './MFAEntry'

var configs = require('../../../config');
const env = process.env.NODE_ENV;
const config = env === 'development' ? configs.dev : configs.build;

export default {
  name: 'TenancyLoginForm',
  props: {
    samlOptionsEnabled: {
      type: Boolean,
      default: true
    },
    authTypesEnabled: {
      type: Boolean,
      default: true
    },
    redirectPages: {
      type: Array,
      default: () => ["Browse", "Meetings", "Users", "Tenancies", "AccountDetails"]
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  components: {
    LoginFormPartial,
    MfaEntry: MFAEntry,
  },
  data () {
    return {
      office365LoginUrl: null,
      samlOptions: [],
      tenancyName: "",
      showAdminLogin: false,
      webappLink: "https://vevox.app",
      showTokenMFAEntry: false,
      loginToken: null,
    }
  },
  computed: {
    ...mapGetters({
      hasFeature: 'featureset/hasFeature'
    }),
    showGraphics() {
      return this.$root.getSetting('show_login_page_graphics');
    },
    signupUrl() {
      if (config.firstStepSignupURL != null && config.firstStepSignupURL !== "") {
        return config.firstStepSignupURL;
      }
      return "https://signup.vevox.com/#/";
    }
  },
  methods: {
    showLogo() {
      return this.$t('show_login_page_logo') === '1';
    },
    adminLogin() {
      this.showAdminLogin = true;
    },
    loginWithSAML(saml_option) {
      window.location = saml_option.loginURL;
    },
    setError: function(error_message) {
      this.$log.info("this: " + this._uid + "  " + this.$refs.loginform);
      this.$refs.loginform.setError(error_message);
    },
    tenancyURL() {
      return this.$root.getPlayDashboardHostName();
    },
    isAuthenticated() {
      return authHandler.isAuthenticated();
    },
    office365login: function() {
      var csrf_token = utils.uuidv4();
      persistentStorage.set("loginCSRFToken", csrf_token);
      var state_json = {
          type: "tenancylogin",
          csrfToken: csrf_token,
          tenancyURL: this.$root.getPlayDashboardHostName()
      };
      window.location.href = this.office365LoginUrl + "&state=" + encodeURIComponent(JSON.stringify(state_json));
    },
    login: function(username, password) {
      authHandler.login(username, password, this.$refs.loginform.lockedOutUrl(), this.$root.getPlayDashboardHostName(), this.$refs.loginform.loginResponse);
    },
    loginWithMFA(request) {
      authHandler.loginWithMFA(request.email, request.password, request.mfaCode, this.$refs.loginform.lockedOutUrl(), this.$root.getPlayDashboardHostName(), this.$refs.loginform.loginResponse);
    },
    loginSuccess: function() {
      this.$emit('loginsuccess');
      var title_key = "page_title_default";
      if (this.$route.meta.title != null) {
        title_key = this.$route.meta.title;
      }
      if (!this.$i18n.i18next.exists(title_key)) {
        var tenancy = authHandler.getAuthTenancy();
        if (tenancy != null) {
          document.title = this.$t('page_title_prefix') + " - " + tenancy.tenancyName;
        }
      }

      if (this.$route.query.redirectURL) {
        if (this.$route.query.redirectURL.startsWith("/project/")) {
          //redirect to Vue in-meeting instead of play

          //redirectURL=/project/123
          var project_id = this.$route.query.redirectURL.substring("/project/".length, this.$route.query.redirectURL.length);
          if (project_id.indexOf("/") > 0) project_id = project_id.substring(0, project_id.indexOf("/"));       //redirectURL=/project/123/#/session/123/polls
          if (project_id.indexOf("#") > 0) project_id = project_id.substring(0, project_id.indexOf("#"));       //redirectURL=/project/123#/session/123/polls
          this.$router.push({ name: 'MeetingDefault', params: { meetingId: project_id } });
        }
        else {
          //should we ever allow redirects into play dashboard anymore? or should we just redirect to Vue default?
          var properties = {
            action:   "redirect",
            path:     this.$route.query.redirectURL,
            username: authHandler.getAuthUserName()
          };
          var play_dashboard_url = this.$root.getPlayDashboardUrl();
          dashboardUserSessionService.getTransferSessionToken(properties, function(response) {
            if (response.data) {
              window.location.href = play_dashboard_url+"/ssotransfer/"+response.data.transferToken;
            } else {
              this.$log.warn("Could not get transfer token");
            }
          });
        }
      } else if (this.$route.query.redirectHash) {
        this.$store.dispatch({type: 'general/setAnnouncementFlag', flag:true});
        var route = this.$router.resolve(this.$route.query.redirectHash);
        var auth_perms = authHandler.getAuthPermissions();
        if (route != null && route.resolved != null && (typeof route.resolved.meta.requiredPermission === 'undefined' || authHandler.getAuthPermissions().indexOf(route.resolved.meta.requiredPermission) > -1)) {
          this.$router.push(this.$route.query.redirectHash);
        }
        else {
          this.loginSuccessDefaultRedirect();
        }
      } else {
        this.loginSuccessDefaultRedirect();
      }
    },
    getChildRoutes(route) {
      var children = route.children;
      if (children == null) children = [];
      var ret = [...children];
      for (let child of children) {
        ret = ret.concat(this.getChildRoutes(child));
      }
      return ret;
    },
    getAllRoutes() {
      var routes = this.$router.options.routes
      var ret = [];
      for (let route of routes) {
        ret.push(route);
        ret = ret.concat(this.getChildRoutes(route));
      }
      return ret;
    },
    loginSuccessDefaultRedirect() {
      this.$store.dispatch({type: 'general/setAnnouncementFlag', flag:true});
      // redirect
      var login_redirect_pages = this.redirectPages;
      var perms = authHandler.getAuthPermissions();
      var found = false;

      var routes = this.getAllRoutes();
      outer:
      for (var j=0; j<login_redirect_pages.length; j++) {
        for (var i=0; i<routes.length; i++) {
          var name = routes[i].name;
          if (name == login_redirect_pages[j]) {
            if (perms.indexOf(routes[i].meta.requiredPermission) != -1) {
              this.$router.replace({
                name: name,
                params: { }
              });
              found = true;
              break outer;
            }
          }
        }
      }
      if (!found) {
        console.error("Could not find page to redirect to, the code monkeys have done a poor job again!");
      }
    },
    loginWithLoginIdWhenLockedOut(login_id) {
      authHandler.loginWithToken(login_id, this.$root.getPlayDashboardHostName(), response => {
        if (response.status === 'success') {
          this.loginSuccess(response);
        } else {
          if (response.exceptionName === "MFARequiredException") {
            this.showTokenMFAEntry = true;
            this.loginToken = login_id;
          }
          else {
            this.setError(this.$t('undefined_error'));
          }
        }
      });
    },
    tokenLoginWithMFA(mfa_code) {
      this.showTokenMFAEntry = false;
      authHandler.loginWithTokenAndMFA(this.loginToken, mfa_code, this.$root.getPlayDashboardHostName(), response => {
        if (response.status === 'success') {
          this.loginSuccess(response);
        } else {
          this.setError(this.$t('undefined_error'));
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.msg == "no_access_contact") {
      this.setError(this.$t('no_access_contact'));
    }
    if (this.$route.query.msg == "invalid_email") {
      this.setError(this.$t('no_access_contact'));
    }
    if (this.$route.query.msg == "user_limit_reached") {
      this.setError(this.$t('user_limit_reached'));
    }

    if (this.isAuthenticated()) {
      this.loginSuccess();
    } else {
      let url = this.$root.getPlayDashboardHostName();
      if (this.samlOptionsEnabled) {
        samlService.getSAMLOptions({url: url}).then(response => {
          this.tenancyName = response.tenancyName;
          if (response.appUrl != null) this.webappLink = "https://" + response.appUrl;

          var title_key = "page_title_default";
          if (this.$route.meta.title != null) {
            title_key = this.$route.meta.title;
          }
          if (!this.$i18n.i18next.exists(title_key)) {
            document.title = this.$t('page_title_prefix') + " - " + this.tenancyName;
          }

          this.samlOptions = response.samlOptions;
        }, (failure) => {
        });
      }
      if (this.authTypesEnabled) {
        dashboardUserService.getEnabledAuthenticationTypes(url, response => {
          if (response.status === "success") {
            if (response.data && response.data != '') {
              for (var i=0; i<response.data.authenticationTypes.length; i++) {
                if (response.data.authenticationTypes[i].authenticationType == "office365") {
                  this.office365LoginUrl = response.data.authenticationTypes[i].authenticationURL;
                  break;
                }
              }
            }
          } else {
            this.$log.warn("Could not get enabled authentication types");
          }
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.samlbuttons {
  width: 100%;
  text-align: center;
}
.logo {
  max-width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/TenancyLoginForm.vue